import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { User, ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from './CartContext';
import CurrencySwitcher from './CurrencySwitcher';

const LogoMark = () => (
  <Link to="/" className="flex flex-col items-center leading-none select-none">
    <span
      className="font-serif text-[34px] md:text-[40px] tracking-tight"
      style={{ color: '#2D5A3D', fontStyle: 'italic', fontWeight: 500 }}
    >
      K-Root
    </span>
    <span
      className="text-[9px] md:text-[10px] tracking-[0.18em] uppercase mt-[-2px]"
      style={{ color: '#2D5A3D' }}
    >
      Less shedding. More hair.
    </span>
  </Link>
);

const Header = () => {
  const { openCart, itemCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { to: '/', label: 'Home' },
    { to: '/products/korean-scalp-revival-bar', label: 'Catalog' },
    { to: '/pages/contact', label: 'Contact' },
  ];

  return (
    <header
      className="sticky top-0 z-40 w-full border-b"
      style={{ backgroundColor: '#F5EDDF', borderColor: 'rgba(45,90,61,0.10)' }}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 h-[72px] md:h-[88px] flex items-center justify-between">
        {/* Left nav (desktop) */}
        <nav className="hidden md:flex items-center gap-8 flex-1">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `text-[14px] tracking-wide btn-hover ${isActive ? 'underline underline-offset-4' : ''}`
              }
              style={{ color: '#2D5A3D' }}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        {/* Mobile menu button - hidden, matches the original yoracare mobile (no hamburger) */}
        <button
          onClick={() => setMenuOpen((s) => !s)}
          className="hidden p-2 -ml-2"
          aria-label="Menu"
          style={{ color: '#2D5A3D' }}
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        {/* Mobile spacer (keeps logo centered) */}
        <div className="md:hidden flex-1" />

        {/* Logo center */}
        <div className="flex-1 flex justify-center">
          <LogoMark />
        </div>

        {/* Right icons */}
        <div className="flex-1 flex items-center justify-end gap-3 md:gap-5">
          <CurrencySwitcher />
          <button aria-label="Account" className="hidden md:inline-flex btn-hover" style={{ color: '#2D5A3D' }}>
            <User size={22} strokeWidth={1.4} />
          </button>
          <button
            aria-label="Cart"
            onClick={openCart}
            className="relative btn-hover"
            style={{ color: '#2D5A3D' }}
          >
            <ShoppingCart size={24} strokeWidth={1.6} />
            <span
              className="absolute -bottom-1 -right-2 text-[10px] rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 font-semibold border-2"
              style={{ backgroundColor: '#FFFFFF', color: '#2D5A3D', borderColor: '#2D5A3D' }}
            >
              {itemCount}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile menu drawer */}
      {menuOpen && (
        <div
          className="md:hidden border-t"
          style={{ borderColor: 'rgba(45,90,61,0.10)' }}
        >
          <nav className="flex flex-col px-6 py-4 gap-3">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setMenuOpen(false)}
                className="text-[15px]"
                style={{ color: '#2D5A3D' }}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
